// One consistent "unlock" panel. Tells people exactly why they're locked out and what to do next.
import { Link } from "../lib/router";
import { useSession } from "../lib/session";
import { SignInPanel } from "./SignInPanel";

const DENIED: Record<string, string> = {
  email: "This email address has already had a free trial.",
  ip: "A free trial has already been used from this network.",
  disposable: "Free trials aren't available for temporary email addresses.",
  disabled: "Free trials are currently unavailable.",
};

export function Paywall({ what = "all 50 lessons and AI adaptation" }: { what?: string }) {
  const { me } = useSession();
  if (!me?.user) {
    return (
      <div className="paywall">
        <p className="paywall-title">Start your 7-day free trial</p>
        <p>Unlock {what}. No card needed: enter your email and you're in.</p>
        <SignInPanel reason="" />
        <p className="muted small">Then US$10/month or US$100/year (2 months free). <Link to="/pricing">See plans</Link></p>
      </div>
    );
  }
  const a = me.access;
  const reason = a.trialDeniedReason ? DENIED[a.trialDeniedReason] : a.trialEndsAt ? "Your 7-day free trial has ended." : "";
  return (
    <div className="paywall">
      <p className="paywall-title">Subscribe to unlock {what}</p>
      {reason && <p>{reason}</p>}
      <p>US$10/month, or US$100/year (2 months free). Cancel any time.</p>
      <Link className="btn btn-primary" to="/pricing">Choose a plan</Link>
    </div>
  );
}
